import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

import useLocaleLoader from '@/shared/composables/useLocaleLoader';

/**
 * Helper at the app level for setting language upon application load if url includes
 * lang param.
 */
export default function useLanguageHelper() {
  const store = useStore();
  const { locale } = useI18n();
  const { switchLocale } = useLocaleLoader();

  async function load() {
    const currentUrl = new URL(window.location.href);
    const lang = currentUrl.searchParams.get('lang');
    if (lang) {
      await switchLocale(lang);
    }
  }

  onMounted(load);

  watch(
    () => store.state.default_locale,
    async (newVal) => {
      if (newVal && newVal !== locale.value) {
        await switchLocale(newVal);
      }
    },
    { immediate: true },
  );
}
